(ns app.front.form.personal-id-render
  (:require [app.domain.form.model :as form-model]
            [app.domain.form.validators :as form-validators]
            [app.front.entities :as entities]
            [app.front.form.render :as fr]
            [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.form-util :as form-util]
            [app.front.view.workspace.subs :as ws-subs]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))


(rf/reg-sub ::validator-fn
  :<- [::ws-subs/country]
  (fn [country _]
    (some-> country keyword form-validators/personal-id-validators)))


(rf/reg-event-fx ::reveal-full-id
  (fn [_ [_ entity-id set-value]]
    {:comm/command {:command    :form/get-full-personal-id
                    :method     :get
                    :data       (util/mmap entity-id)
                    :on-success [::reveal-full-id.success set-value]}}))


(rf/reg-event-fx ::reveal-full-id.success
  (fn [_ [_ set-value status data]]
    (when set-value
      (-> data vals first vals first set-value))
    {:dispatch [::entities/merge-entity-db status data]}))


(rf/reg-sub ::reveal-visible?
  :<- [:session/authority-groups]
  (fn [user-authority-groups [_ current-id]]
    (and (string? current-id)
         (str/includes? current-id "*-")
         (some :group-admin? user-authority-groups))))


(defn id-format-invalid-text [{:keys [tr value visited]}]
  (let [valid? (<sub [::validator-fn])]
    (when (and (not (str/blank? value))
               visited
               valid?
               (not (valid? value)))
      (tr [:form-field/personal-id-error]))))


(defn form-element-invalid-text [{:keys [tr] :as ctx} attr value visited]
  (if (and (not (form-model/field-value-is-set? {:form.field/value value}))
           (-> attr :form.field/required)
           (fr/show-required-as-invalid? ctx visited))
    (tr [:required-field])
    (id-format-invalid-text (util/mmap tr value visited))))


(defn personal-id-input
  [{:keys [tr entity-id input-id value label-text placeholder invalid-text set-val required on-blur]}]
  [:div.flex.items-end.gap-2
   [ui/text-input {:id           input-id
                   :value        value
                   :label-text   label-text
                   :placeholder  placeholder
                   :invalid      (boolean invalid-text)
                   :invalid-text invalid-text
                   :on-change    #(set-val (futil/tval %))
                   :on-blur      on-blur
                   :required     required}]
   (when (<sub [::reveal-visible? value])
     [:div
      (cc/button {:on-click #(>evt [::reveal-full-id entity-id set-val])
                  :kind     :ghost
                  :size     :field}
                 (tr [:form-field/personal-id-reveal]))])])


(defn personal-id-form-component
  [{:keys [target-id form-id tr] :as ctx} form-field {:keys [field placeholder] :as attr}]
  (r/with-let [*value    (r/atom (:form.field/personal-id form-field))
               *visited? (r/atom false)
               set-val   (fn [v]
                           (reset! *value v))]
    (let [ff-id          (:db/id form-field)
          value-changed? (not= (:form.field/personal-id form-field) @*value)
          invalid-text   (form-element-invalid-text ctx attr @*value (and @*visited? value-changed?))
          valid?         (<sub [::validator-fn])
          required       (-> attr :form.field/required)
          on-blur        (fn [e]
                           (let [v (futil/tval e)]
                             (when value-changed?
                               (reset! *visited? true)
                               (when (valid? v)
                                 (>evt [::form-util/update-form-field
                                        target-id
                                        {:form-id                form-id
                                         :field-key              field
                                         :form-field-id          (:db/id form-field)
                                         :form.field/personal-id v}])))))]
      [personal-id-input (util/mmap {:entity-id  ff-id
                                     :input-id   (fr/dom-id ctx ff-id "pid-input")
                                     :value      @*value
                                     :label-text (fr/label-text attr)}
                                    tr
                                    placeholder
                                    invalid-text
                                    set-val
                                    required
                                    on-blur)])))


(defmethod fr/render :personal-id [ctx _ current-id [_ {:keys [field] :as attr}]]
  (let [form-field (fr/child-of current-id field ctx)]
    ;; Force redraw when the masked value is updated to the entity db after ::form-util/update-form-field completes
    ^{:key (str (:db/id form-field) "-" (:entity/version form-field))}
    [personal-id-form-component ctx form-field attr]))
